// Calibration Screen - Full-Width Responsive Layout
import { useState } from 'react';
import { useApp } from '../hooks/useApp';
import { Container, Text, Card, Button, IconButton, ProgressBar } from '../components/ui';
import Icons from '../components/Icons';
import BottomNav from '../components/BottomNav';

const colorSteps = [
    { name: 'Đỏ', color: '#FF0000', bgColor: 'bg-red-500' },
    { name: 'Vàng', color: '#FFFF00', bgColor: 'bg-yellow-400' },
    { name: 'Xanh lá', color: '#00FF00', bgColor: 'bg-green-500' },
    { name: 'Xanh dương', color: '#0000FF', bgColor: 'bg-blue-500' },
    { name: 'Trắng', color: '#FFFFFF', bgColor: 'bg-white' },
];

function CalibrationScreen() {
    const { goBack, calibrationData, setCalibrationData, showToast } = useApp();
    const [step, setStep] = useState(0);
    const [calibrating, setCalibrating] = useState(false);

    const handleCalibrate = async () => {
        setCalibrating(true);
        await new Promise(r => setTimeout(r, 1500));

        if (step < colorSteps.length - 1) {
            setStep(step + 1);
        } else {
            setCalibrationData({
                calibrated: true,
                accuracy: 95,
                lastUpdate: new Date().toISOString(),
            });
            showToast('Hiệu chuẩn hoàn tất!', 'success');
            goBack();
        }
        setCalibrating(false);
    };

    const progress = ((step + 1) / colorSteps.length) * 100;

    return (
        <Container className="min-h-screen bg-theme-bg pb-24" safe>
            <div className="header-fullwidth">
                <div className="header-content">
                    <IconButton onClick={goBack}><Icons.Back /></IconButton>
                    <Text className="font-semibold sm:text-lg">Hiệu chuẩn màu</Text>
                    <div className="w-11" />
                </div>
            </div>

            <div className="main-content py-4 sm:py-6">
                {/* Info */}
                <Card className="mb-6 text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-red-500 via-yellow-400 to-blue-500 flex items-center justify-center">
                        <Icons.Color />
                    </div>
                    <Text variant="h4" className="mb-2">Hiệu chuẩn màu sắc</Text>
                    <Text variant="caption" className="max-w-xs mx-auto">
                        Giúp AI nhận diện màu sắc chính xác hơn dựa trên điều kiện ánh sáng của bạn.
                    </Text>
                </Card>

                {/* Progress */}
                <div className="mb-6">
                    <div className="flex justify-between mb-2">
                        <Text variant="small">Tiến độ</Text>
                        <Text variant="small">{step + 1}/{colorSteps.length}</Text>
                    </div>
                    <ProgressBar progress={progress} />
                </div>

                {/* Color display */}
                <Card className="mb-6 text-center">
                    <Text className="font-semibold mb-4">Hiệu chuẩn màu: {colorSteps[step].name}</Text>
                    <div
                        className={`w-32 h-32 mx-auto rounded-2xl ${colorSteps[step].bgColor} mb-4 ${calibrating ? 'animate-pulse' : ''}`}
                        style={{ boxShadow: `0 10px 40px ${colorSteps[step].color}40` }}
                    />
                    <Text variant="caption">
                        {calibrating ? 'Đang phân tích...' : 'Đặt điện thoại cách mẫu màu 20cm'}
                    </Text>
                </Card>

                {/* Action */}
                <Button
                    className="w-full"
                    onClick={handleCalibrate}
                    disabled={calibrating}
                >
                    {calibrating ? 'Đang hiệu chuẩn...' : step < colorSteps.length - 1 ? 'Tiếp tục' : 'Hoàn tất'}
                </Button>
            </div>

            <BottomNav />
        </Container>
    );
}

export default CalibrationScreen;
